
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Divider, VStack } from '@chakra-ui/react';
import { GetStaticProps } from 'next';
import I18nProvider from 'next-translate/I18nProvider';
import useTranslation from 'next-translate/useTranslation';
import HeadModule from '../../components/Modules/HeadModule';
import ServiceHeader from '../../components/Modules/ServiceHeader';
import ServiceList from '../../components/Modules/ServiceList';
import ServiceGroupButtons from '../../components/ServiceGroup/ServiceGroupButtons';
import SkillSingleInputPlayground from '../../components/Skill/SingleInputOutput/SkillSingleInputPlayground';
import SkillOptions from '../../components/Skill/SkillOptions';
import { GPT_3_TOKEN_LENGTH } from '../../constants/gpt3';
import { SKILL_FORMAL_REWRITING_EXAMPLES } from '../../constants/skillExamples';
import { getFourRandomSkills, REWRITING_SKILLS, SKILL_FORMAL_REWRITING } from '../../constants/skills';
import examplesDE from '../../locales/de/examples.json';
import examplesEN from '../../locales/en/examples.json';
import examplesFR from '../../locales/fr/examples.json';
import { SkillProvider } from '../../utils/SkillContext';
const SkillFormalRewriting = ({ otherServices }: any) => {
    const { lang } = useTranslation();
    const skillsGroup = REWRITING_SKILLS;
    const maxLength = 250 * GPT_3_TOKEN_LENGTH;
    const { t } = useTranslation('skill-formal-rewriting');
    return (<I18nProvider lang={lang} namespaces={{ examplesFR, examplesEN, examplesDE }}>
      <>
        <HeadModule title='meta_title_skill_formal_rewriting' description='meta_description_skill_formal_rewriting'/>
        <VStack w='full' spacing={20}>
          <VStack w='full' spacing={10}>
            <ServiceHeader serviceGroup={skillsGroup}/>
            <ServiceGroupButtons serviceGroup={skillsGroup}/>
            <SkillProvider skill={SKILL_FORMAL_REWRITING} skillExamples={SKILL_FORMAL_REWRITING_EXAMPLES} skillGroup={skillsGroup}>
              <SkillSingleInputPlayground maxLength={maxLength}>
                <SkillOptions title={t('skill_formal_rewriting_subtitle')}/>
              </SkillSingleInputPlayground>
            </SkillProvider>
          </VStack>
          <Divider variant='separator2' w={64}/>
          <ServiceList title={t('common:our_other_products')} serviceGroups={JSON.parse(otherServices)}/>
        </VStack>
      </>
    </I18nProvider>);
};
const getStaticProps: GetStaticProps = async () => {
    const otherServices = getFourRandomSkills();
    return {
        props: {
            otherServices: JSON.stringify(otherServices),
        },
        revalidate: 900,
    };
};
// noinspection JSUnusedGlobalSymbols
export default SkillFormalRewriting;

    async function __Next_Translate__getStaticProps__19bb2fd5b9e__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/rewriting/formal-rewriting',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19bb2fd5b9e__ as getStaticProps }
  